var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextekLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 61,
    viewBox: "0 0 72 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.53833 45.2104L0 60.5L61.3569 45.2104V35.2821C61.3569 35.2821 57.7827 33.0979 51.0315 35.2821C51.0315 35.2821 59.3713 35.0835 59.3713 36.8706C59.5698 38.8563 59.7684 43.4233 59.7684 43.4233L6.94981 55.3373L8.53833 45.2104Z",
    fill: "#2858A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8688 38.4592L15.4882 46.7989V50.9688L46.4645 43.6219L45.8688 38.4592Z",
    fill: "url(#paint0_linear_11_186)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9334 36.2749C36.9334 36.2749 21.4452 40.4448 20.6509 38.4592C19.8567 36.4735 27.7993 33.2965 39.9118 30.1194L13.304 33.8921L9.53122 7.08572C9.53122 7.08572 30.5792 2.32014 45.2731 2.5187L47.4573 28.3323L49.2444 28.1337L50.0387 0.731606C50.0387 0.731606 12.9068 -1.05548 3.37567 5.29863L11.1198 36.4735L17.2753 35.8778C17.0767 35.8778 9.72979 47.5932 36.9334 36.2749Z",
    fill: "#2858A5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9168 51.1674C64.534 51.1674 63.3426 47.5932 63.3426 45.8061H69.4982C69.4982 45.409 69.4982 44.2176 69.2996 43.4233C68.9025 41.6362 65.3283 40.842 63.1441 42.2319C63.1441 42.2319 62.9455 42.2319 62.9455 42.4305C62.7469 42.6291 62.5484 42.8276 62.3498 42.8276C60.9598 44.2176 60.9598 46.2033 60.9598 46.6004C61.1584 53.7488 64.1369 54.7416 65.5269 54.7416C67.314 54.7416 70.491 50.5717 71.4838 47.9904C70.0939 50.1746 68.5054 50.7703 66.9168 51.1674Z",
    fill: "#7A7C7E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11_186",
    x1: 16.9105,
    y1: 49.4521,
    x2: 46.6593,
    y2: 40.4108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00754523,
    stopColor: "#F6F6FB",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0743793,
    stopColor: "#C5CAE5",
    stopOpacity: 0.0743793
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.147,
    stopColor: "#9EA7D2",
    stopOpacity: 0.147
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2237,
    stopColor: "#808DC4",
    stopOpacity: 0.2237
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3057,
    stopColor: "#677AB9",
    stopOpacity: 0.3057
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3946,
    stopColor: "#536DB1",
    stopOpacity: 0.3946
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#4163AC",
    stopOpacity: 0.493
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.606,
    stopColor: "#335DA8",
    stopOpacity: 0.606
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7466,
    stopColor: "#2A59A6",
    stopOpacity: 0.7466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2858A5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextekLogo);
export default __webpack_public_path__ + "static/media/nextek-logo.0bc234a478f99645113f07851eeeeb4f.svg";
export { ForwardRef as ReactComponent };